export const getters = {
    loadingCompany: state => state.loadingCompany,
    errorCompany: state => state.errorCompany,
    company: state => state.company
}